<form class="setup-form strategy-form-section responsive-flex padding-bottom" autocomplete="off">
    <div class="display-flex-column pad-8-hr full-width">

        <div class="symbol-search half-width">
            <mat-form-field class="full-width ut-pro-mat-form-field label-field" appearance="outline" color="accent">
                <label class="ut-label">Select Symbols {{update ? '(Please remove current symbol to replace the symbol)' : ''}}</label>
                <mat-autocomplete #symbolAutoComplete="matAutocomplete" (optionSelected)="addSymbol($event)">
                    <mat-option *ngFor="let symbol of searchedSymbols" [value]="symbol">
                        {{ symbol.market_id }} {{ symbol.scrip_name }}
                    </mat-option>
                </mat-autocomplete>

                <input matInput [formControl]="symbolSearchControl" [matAutocomplete]="symbolAutoComplete"
                    class="full-width">
                <mat-hint class="mat-error" *ngIf="differentSegmentError">You can add only symbols of one segment</mat-hint>
            </mat-form-field>
        </div>

        <mat-chip-list class="margin-vr" *ngIf="symbols.length">
            <mat-chip *ngFor="let symbol of symbols" [removable]="true" (removed)="removeSymbol(symbol)"
                [class.chip-positive]="symbol.quoteObj?.isTickUp" [class.chip-negative]="symbol.quoteObj?.isTickDown">
                <mat-icon matChipRemove class="no-margin margin-8-right">cancel</mat-icon>
                <!-- {{ symbol.market_id }} -->
                {{ symbol.scrip_name }}
                <span class="spacer"></span>
                <!-- TODO: Check symbol precision -->
                <div class="margin-left ltp">{{ symbol.quoteObj?.LTP | precision:2 }}</div>
            </mat-chip>
        </mat-chip-list>
    </div>
</form>